module.exports = __webpack_public_path__ + "img/beneficio-seguro.45d54d16.svg";